import _ from 'lodash';
import Vue from 'vue';
import { getJSON, set } from '../partials/locker';

let products = getJSON('products');

if (!_.isArray(products)) {
  products = [];
}

// initial state
const state = {
  products: products,
  checkoutStatus: 1
};

// getters
const getters = {
  cartTotalPrice(state, getters) {
    return getters.products.reduce((total, product) => {
      return total + product.price * product.quantity - product.minusAmount;
    }, 0);
  },
  products(state) {
    return state.products;
  },
  productCount(state) {
    return state.products.length;
  }
};

// actions
const actions = {
  addProductToCart({ commit, rootGetters }, { product }) {
    let quantity = _.get(product, 'quantity', 0);

    product.users = [];

    for (let n = 0; n < quantity; n++) {
      let user = {
        name: rootGetters['user/name'],
        phone: rootGetters['user/phone'],
        email: rootGetters['user/email']
      };
      product.users.push(user);
    }

    commit('pushProductToCart', product);
  }
};

// mutations
const mutations = {
  setCartProducts(state, products) {
    state.products = products;
    set('products', state.products);
  },
  setCartProductsDiscount(
    state,
    {
      index,
      bonusDis,
      bonusDisTemp,
      enjoyDis,
      couponDis,
      couponDisTemp,
      payPrice,
      minusAmount,
      disCoupons,
      disCouponsId,
      ticketNo,
      ticketNoTemp,
      enJoyRes,
      balanceEnjoy,
      denomination,
      bonusDefaultNum,
      bonusNumTemp,
      enjoyDefaultNum,
      isSwitchOn,
      EventMastId,
      EventDetlId,
      DESCRITPION,
      DiscTypePoint,
      DscSku,
      SkuNoPoint,
      SkuNo30,
      ReturnSkuNo30,
      DiscType30,
      Grno30,
      rebateName30,
      accountType,
      copu_type,
      SkuNo10,
      ReturnSkuNo10,
      DiscType10,
      Grno10,
      rebateName10,
      TempSave,
      couponInfoTemp,
      RbonusPoints
    }
  ) {
    let product = state.products[index];

    if (bonusDis !== undefined) {
      product.bonusDis = parseInt(bonusDis);
    }

    if (bonusDisTemp !== undefined) {
      product.bonusDisTemp = bonusDisTemp;
    }

    if (enjoyDis !== undefined) {
      product.enjoyDis = parseInt(enjoyDis);
    }

    if (couponDis !== undefined) {
      product.couponDis = parseInt(couponDis);
    }

    if (minusAmount !== undefined) {
      product.minusAmount = minusAmount;
    }

    if (payPrice !== undefined) {
      product.payPrice = payPrice;
    }

    if (disCoupons !== undefined) {
      product.disCoupons = disCoupons;
    }

    if (disCouponsId !== undefined) {
      product.disCouponsId = disCouponsId;
    }

    if (ticketNo !== undefined) {
      product.ticketNo = ticketNo;
    }

    if (enJoyRes !== undefined) {
      product.enJoyRes = enJoyRes;
    }

    if (balanceEnjoy !== undefined) {
      product.balanceEnjoy = balanceEnjoy;
    }

    if (denomination !== undefined) {
      product.denomination = denomination;
    }

    if (bonusDefaultNum !== undefined) {
      product.bonusDefaultNum = bonusDefaultNum;
    }

    if (bonusNumTemp !== undefined) {
      product.bonusNumTemp = bonusNumTemp;
    }

    if (enjoyDefaultNum !== undefined) {
      product.enjoyDefaultNum = enjoyDefaultNum;
    }

    if (isSwitchOn !== undefined) {
      product.isSwitchOn = !product.isSwitchOn;
    }

    if (couponDisTemp !== undefined) {
      product.couponDisTemp = couponDisTemp;
    }

    if (ticketNoTemp !== undefined) {
      product.ticketNoTemp = ticketNoTemp;
    }

    if (EventMastId !== undefined) {
      product.EventMastId = EventMastId;
    }

    if (EventDetlId !== undefined) {
      product.EventDetlId = EventDetlId;
    }

    if (DESCRITPION !== undefined) {
      product.DESCRITPION = DESCRITPION;
    }

    if (DiscTypePoint !== undefined) {
      product.DiscTypePoint = DiscTypePoint;
    }

    if (DscSku !== undefined) {
      product.DscSku = DscSku;
    }

    if (SkuNoPoint !== undefined) {
      product.SkuNoPoint = SkuNoPoint;
    }

    if (SkuNo30 !== undefined) {
      product.SkuNo30 = SkuNo30;
    }

    if (ReturnSkuNo30 !== undefined) {
      product.ReturnSkuNo30 = ReturnSkuNo30;
    }

    if (DiscType30 !== undefined) {
      product.DiscType30 = DiscType30;
    }

    if (Grno30 !== undefined) {
      product.Grno30 = Grno30;
    }

    if (rebateName30 !== undefined) {
      product.rebateName30 = rebateName30;
    }

    if (accountType !== undefined) {
      product.accountType = accountType;
    }

    if (copu_type !== undefined) {
      product.copu_type = copu_type;
    }

    if (SkuNo10 !== undefined) {
      product.SkuNo10 = SkuNo10;
    }

    if (ReturnSkuNo10 !== undefined) {
      product.ReturnSkuNo10 = ReturnSkuNo10;
    }

    if (DiscType10 !== undefined) {
      product.DiscType10 = DiscType10;
    }

    if (Grno10 !== undefined) {
      product.Grno10 = Grno10;
    }

    if (rebateName10 !== undefined) {
      product.rebateName10 = rebateName10;
    }

    if (TempSave !== undefined) {
      product.TempSave = TempSave;
    }

    if (couponInfoTemp !== undefined) {
      product.couponInfoTemp = couponInfoTemp;
    }

    if (RbonusPoints !== undefined) {
      product.RbonusPoints = RbonusPoints;
    }

    set('products', state.products);
  },
  pushProductToCart(state, product) {
    state.products.push(product);
    set('products', state.products);
  },

  removeCartItem(state, index) {
    Vue.delete(state.products, index);
    set('products', state.products);
  },

  setCheckoutStatus(state, status) {
    state.checkoutStatus = status;
  },

  setUser(state, { name, phone, email, parentIndex, index }) {
    let product = state.products[parentIndex];
    let user = product.users[index];
    if (name !== undefined) {
      user.name = name;
    }

    if (phone !== undefined) {
      user.phone = phone;
    }

    if (email !== undefined) {
      user.email = email;
    }

    set('products', state.products);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
